import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bonuses, builtToHelp } from '../data/coachSystem';
export function BonusSection() {
  return <section className="bg-white py-11 sm:py-14" aria-labelledby="bonus-title" data-id="element-11" data-mp="1ofly5p68bcqc">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-5xl" data-id="element-12" data-mp="22ebwt98p5kgt">
        <p className="eyebrow text-[0.66rem] font-semibold text-sand sm:text-[0.72rem]" data-id="element-13" data-mp="1yfcsnqushrqf">
          Also included at no extra cost
        </p>
        <h2 id="bonus-title" className="mt-3 font-display text-[1.75rem] leading-[1.15] tracking-tight text-navy sm:text-[2.25rem]" data-id="element-14" data-mp="1am2z6215em2n">
          5 premium resources for the moments beyond practice planning.
        </h2>

        <ol className="mt-6 grid grid-cols-2 gap-2.5 sm:gap-4" data-id="element-15" data-mp="1eozmu75jp8dg">
          {bonuses.map(bonus => {
          const isWide = bonus.number === 5;
          return <li key={bonus.number} className={`flex h-full flex-col items-center rounded-xl border border-navy-line bg-ivory p-4 text-center ${isWide ? 'col-span-2 sm:p-5' : ''}`} data-id="element-16" data-mp="mz4k98sofm6u">
                <span className="text-[0.6rem] font-bold uppercase tracking-[0.16em] text-sand" data-id="element-17" data-mp="2ep38jphbes2a">
                  Bonus {bonus.number}
                </span>
                <h3 className="mt-1.5 text-[0.88rem] font-semibold leading-snug text-navy sm:text-[0.95rem]" data-id="element-18" data-mp="2ofxu0rmqlnmo">
                  {bonus.title}
                </h3>
                <p className={`mt-2 text-[0.79rem] leading-relaxed text-navy-muted sm:text-[0.86rem] ${isWide ? 'max-w-2xl' : ''}`} data-id="element-19" data-mp="1vsbupvkjl55m">
                  {bonus.description}
                </p>
              </li>;
        })}
        </ol>

        <div className="mt-7 border-t border-navy-line pt-6" data-id="element-20" data-mp="3c73drhvst029">
          <h3 className="text-[0.7rem] font-bold uppercase tracking-[0.16em] text-teal-deep" data-id="element-21" data-mp="3c8whopf1166k">
            Built to help you:
          </h3>
          <ul className="mx-auto mt-3.5 grid max-w-3xl gap-2.5 sm:grid-cols-2" data-id="element-22" data-mp="1h2m153sa1buw">
            {builtToHelp.map(item => <li key={item} className="flex items-start justify-center gap-2.5 text-left" data-id="element-23" data-mp="1c3iytr3oljqm">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-24" data-mp="1m2i7h9og5fdm" />
                <span className="text-[0.92rem] font-medium leading-snug text-navy" data-id="element-25" data-mp="ydyy0qtnuwjy">
                  {item}
                </span>
              </li>)}
          </ul>
          <p className="mx-auto mt-5 max-w-3xl text-[0.92rem] leading-relaxed text-navy-muted" data-id="element-26" data-mp="175r7ay6y7zmy">
            Useful across youth, middle school, high school and club volleyball
            programs. Always adapt the resources to your players, competition
            level, organization and applicable rules.
          </p>
        </div>
      </div>
    </section>;
}